import AccountInfo from '@components/pengaturanAkun/accountInfo'
import ChangePassword from '@components/pengaturanAkun/changePassword'

const PengaturanAkunRoute = () => {
  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <h1 className="text-center text-xl md:text-2xl lg:text-4xl font-semibold">Pengaturan Akun</h1>
      </div>

      <div>
        <AccountInfo />
      </div>

      <div>
        <ChangePassword />
      </div>
    </div>
  )
}

export default PengaturanAkunRoute